export default "# Project Versions\n\nHere you can manage the versions of the project for SBOM deliveries.\n"